import { IPlanInfo } from 'src/app/interfaces/plan-info.interface';

export const REGIMEN_LIST = [
  { "id": "601", "value": "General de Ley Personas Morales" },
  { "id": "603", "value": "Personas Morales con Fines no Lucrativos" },
  { "id": "605", "value": "Sueldos y Salarios e Ingresos Asimilados a Salarios" },
  { "id": "606", "value": "Arrendamiento" },
  { "id": "608", "value": "Demás ingresos" },
  { "id": "609", "value": "Consolidación" },
  { "id": "610", "value": "Residentes en el Extranjero sin Establecimiento Permanente en México" },
  { "id": "611", "value": "Ingresos por Dividendos (socios y accionistas)" },
  { "id": "612", "value": "Personas Físicas con Actividades Empresariales y Profesionales" },
  { "id": "614", "value": "Ingresos por intereses" },
  { "id": "616", "value": "Sin obligaciones fiscales" },
  { "id": "620", "value": "Sociedades Cooperativas de Producción que optan por diferir sus ingresos" },
  { "id": "621", "value": "Incorporación Fiscal" },
  { "id": "622", "value": "Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras" },
  { "id": "623", "value": "Opcional para Grupos de Sociedades" },
  { "id": "624", "value": "Coordinados" },
  { "id": "628", "value": "Hidrocarburos" },
  { "id": "607", "value": "Régimen de Enajenación o Adquisición de Bienes" },
  { "id": "629", "value": "De los Regímenes Fiscales Preferentes y de las Empresas Multinacionales" },
  { "id": "630", "value": "Enajenación de acciones en bolsa de valores" },
  { "id": "615", "value": "Régimen de los ingresos por obtención de premios" },
  { "id": "625", "value": "Régimen de Actividades Empresariales con ingreso a través de las plataformas tecnológicas" },
  { "id": "626", "value": "Régimen Simplificado de Confianza" }
];

export const LINE_OF_BUSINESS_LIST = [
  { "id": "CI", "value": "Contador Independiente" },
  { "id": "D", "value": "Despacho Contable" },
  { "id": "PYMENOCP", "value": "PyME" }
];

export const FUENTE_LIST = [
  { "id": "439", "value": "Facebook" },
  { "id": "441", "value": "Instagram" },
  { "id": "442", "value": "Correo" },
  { "id": "351", "value": "Recomendación" },
];

export const PROFESIONAL_LIST = [
  "RFCs Descarga automática de CFDIs desde el SAT",
  "Contabilidad y reportes",
  "Estados financieros",
  "Tesorería y conciliación",
  "Cálculo automático de impuestos",
  "Auditoría",
  "Cotizaciones",
  "Contabilidad electrónica",
  "Migración automática desde Contpaq",
  "APP Móvil para consulta y facturación",
  "Emisión de facturas y complementos (adquisición adicional de paquete de timbres)"
];

export const PIPEDRIVE_REFERENCE = [
  { "id": "3", "value": "Facebook" },
  { "id": "4", "value": "Instagram" },
  { "id": "12", "value": "Correo" },
  { "id": "1", "value": "Recomendación" },
]
export const PREMIUM_LIST = [
  "RFCs ilimitados",
  "Descarga automática de CFDIs desde el SAT",
  "Contabilidad, Tesorería, Auditoría y Reportes",
  "Cálculo automático de impuestos",
  "Presentación automática de DIOT",
  "Contabilidad Electrónica y Estados Financieros",
  "Cálculo y timbrado de Nómina",
  "Timbres ilimitados",
  `Descarga automática y organización de documentos por cliente:
    <ul>
    <li>Constancia</li>
    <li>Opinión de cumplimiento, IMSS e INFONAVIT</li>
    <li>Comunicados del Buzón Tributario SAT</li>
    <li>Declaraciones</li>
    </ul>`,
  "Facturación recurrente y cobranza",
  "App móvil para emisión de facturas y consulta de reportes",
]

export const START_HTML = `
<ul>
  <li>5 RFCs incluidos</li>
</ul>
<div class="feature-subtitle">Incluido en ambos planes</div>
<ul>
  <li>1 usuario contador incluido</li>
  <li>1 usuario Plus por cada RFC, para tus clientes</li>
  <li>Descarga automática de CFDIs desde el SAT</li>
  <li>Contabilidad, Tesorería, Auditoría y Reportes</li>
  <li>Cálculo automático de impuestos</li>
  <li>Presentación automática de DIOT</li>
  <li>Contabilidad Electrónica y Estados Financieros</li>
  <li>Cálculo y timbrado de Nómina</li>
  <li>Timbres ilimitados</li>
  <li>Descarga automática y organización de documentos por cliente:
    <ul>
      <li>Constancia de RFC</li>
      <li>Opinión de Cumplimiento SAT, IMSS e INFONAVIT</li>
      <li>Comunicados del Buzón Tributario SAT</li>
      <li>Declaraciones</li>
    </ul>
  </li>
  <li>Facturación recurrente y cobranza</li>
  <li>App móvil para emisión de facturas y consulta de reportes</li>
  <li>Capacitación y soporte en línea</li>
  <li>Servidores y Actualizaciones</li>
  <li>Timbres ilimitados</li>
  <li>Conexión API</li>
  <li>App móvil para facturación y consulta</li>
</ul>`;

export const PRO_HTML = `
<ul>
  <li>10 RFCs incluidos</li>
  <li>Suma usuarios y/o RFCs según tus necesidades</li>
</ul>
<div class="feature-subtitle">Incluido en ambos planes</div>
<ul>
  <li>1 usuario contador incluido</li>
  <li>1 usuario Plus por cada RFC, para tus clientes</li>
  <li>Descarga automática de CFDIs desde el SAT</li>
  <li>Contabilidad, Tesorería, Auditoría y Reportes</li>
  <li>Cálculo automático de impuestos</li>
  <li>Presentación automática de DIOT</li>
  <li>Contabilidad Electrónica y Estados Financieros</li>
  <li>Cálculo y timbrado de Nómina</li>
  <li>Timbres ilimitados</li>
  <li>Descarga automática y organización de documentos por cliente:
    <ul>
      <li>Constancia de RFC</li>
      <li>Opinión de Cumplimiento SAT, IMSS e INFONAVIT</li>
      <li>Comunicados del Buzón Tributario SAT</li>
      <li>Declaraciones</li>
    </ul>
  </li>
  <li>Facturación recurrente y cobranza</li>
  <li>App móvil para emisión de facturas y consulta de reportes</li>
  <li>Capacitación y soporte en línea</li>
  <li>Servidores y Actualizaciones</li>
  <li>Timbres ilimitados</li>
  <li>Conexión API</li>
  <li>App móvil para facturación y consulta</li>
</ul>`;

export const DISCOUNT_TABLE: { [key: number]: number } = {
  1: 0,
  2: 10,
  3: 20,
  4: 30,
  5: 40,
};

/** Desactiva descuento por volumen sin eliminar la lógica asociada. */
export const VOLUME_DISCOUNT_ENABLED = false;

export const DISCOUNT_HEADER_TEXT: { [key: string]: string } = {
  'PREMIUM MENSUAL': '50% de descuento en tus primeros 3 meses. En pago anual 25% de descuento',
  'PREMIUM ANUAL': 'En pago anual 25% de descuento',
  'PROFESIONAL MENSUAL': '50% de descuento en tus primeros 3 meses. En pago anual 25% de descuento',
  'PROFESIONAL ANUAL': 'En pago anual 25% de descuento',
  'START MENSUAL': '50% de descuento en tus primeros 3 meses. En pago anual 25% de descuento',
  'START ANUAL': 'En pago anual 25% de descuento',
  'PRO MENSUAL': '50% de descuento en tus primeros 3 meses. En pago anual 25% de descuento',
  'PRO ANUAL': 'En pago anual 25% de descuento',
};

export const DISCOUNT_TEXT: { [key: string]: string } = {
  'PREMIUM MENSUAL': 'Promoción de Bienvenida: 50% de descuento en cada una de tus primeras 3 mensualidades. Promoción para cuentas nuevas. No aplica en recontrataciones.',
  'PREMIUM ANUAL': 'Promoción 25% de descuento en pago anual. Descuento aplica en el primer año de contratación.',
  'PROFESIONAL MENSUAL': 'Promoción de Bienvenida: 50% de descuento en cada una de tus primeras 3 mensualidades. Promoción para cuentas nuevas. No aplica en recontrataciones.',
  'PROFESIONAL ANUAL': 'Promoción 25% de descuento en pago anual. Descuento aplica en el primer año de contratación.',
  'START MENSUAL': 'Promoción de Bienvenida: 50% de descuento en cada una de tus primeras 3 mensualidades. Promoción para cuentas nuevas. No aplica en recontrataciones.',
  'START ANUAL': 'Promoción 25% de descuento en pago anual. Descuento aplica en el primer año de contratación.',
  'PRO MENSUAL': 'Promoción de Bienvenida: 50% de descuento en cada una de tus primeras 3 mensualidades. Promoción para cuentas nuevas. No aplica en recontrataciones.',
  'PRO ANUAL': 'Promoción 25% de descuento en pago anual. Descuento aplica en el primer año de contratación.',
};

export const REFERRER_TEXT: { [key: string]: string } = {
  'PREMIUM MENSUAL': 'DESCUENTO POR PROGRAMA DE REFERIDOS. Válido durante los 4 primeros meses de suscripción. Promoción para cuentas nuevas. No aplica en recontrataciones.',
  'PREMIUM ANUAL': 'DESCUENTO POR PROGRAMA DE REFERIDOS. Válido durante el 1er año de suscripción. Promoción para cuentas nuevas. No aplica en recontrataciones.',
  'PROFESIONAL MENSUAL': 'DESCUENTO POR PROGRAMA DE REFERIDOS. Válido durante los 4 primeros meses de suscripción. Promoción para cuentas nuevas. No aplica en recontrataciones.',
  'PROFESIONAL ANUAL': 'DESCUENTO POR PROGRAMA DE REFERIDOS. Válido durante el 1er año de suscripción. Promoción para cuentas nuevas. No aplica en recontrataciones.',
  'START MENSUAL': 'DESCUENTO POR PROGRAMA DE REFERIDOS. Válido durante los 4 primeros meses de suscripción. Promoción para cuentas nuevas. No aplica en recontrataciones.',
  'START ANUAL': 'DESCUENTO POR PROGRAMA DE REFERIDOS. Válido durante el 1er año de suscripción. Promoción para cuentas nuevas. No aplica en recontrataciones.',
  'PRO MENSUAL': 'DESCUENTO POR PROGRAMA DE REFERIDOS. Válido durante los 4 primeros meses de suscripción. Promoción para cuentas nuevas. No aplica en recontrataciones.',
  'PRO ANUAL': 'DESCUENTO POR PROGRAMA DE REFERIDOS. Válido durante el 1er año de suscripción. Promoción para cuentas nuevas. No aplica en recontrataciones.',
}

export const ANNUAL_LEGEND_TEXT =
  'Anual: paga 10 meses y usa 12 (ahorro de 17%) en cualquiera de los dos planes, RFCs o usuarios adicionales.';

export const VOLUMEN_DISCOUNT_TEXT: { [key: string]: string } = {
  'PREMIUM MENSUAL': 'Descuento por volumen de usuarios desde el 10% hasta el 40% en función de la cantidad de usuarios que requiera',
  'PREMIUM ANUAL': 'Descuento por volumen de usuarios desde el 10% hasta el 40% en función de la cantidad de usuarios que requiera',
  'PROFESIONAL MENSUAL': 'Descuento por volumen de usuarios desde el 10% hasta el 40% en función de la cantidad de usuarios que requiera',
  'PROFESIONAL ANUAL': 'Descuento por volumen de usuarios desde el 10% hasta el 40% en función de la cantidad de usuarios que requiera',
  'START MENSUAL': 'Descuento por volumen de usuarios desde el 10% hasta el 40% en función de la cantidad de usuarios que requiera',
  'START ANUAL': 'Descuento por volumen de usuarios desde el 10% hasta el 40% en función de la cantidad de usuarios que requiera',
  'PRO MENSUAL': 'Descuento por volumen de usuarios desde el 10% hasta el 40% en función de la cantidad de usuarios que requiera',
  'PRO ANUAL': 'Descuento por volumen de usuarios desde el 10% hasta el 40% en función de la cantidad de usuarios que requiera',
}
